<template>
  <div>
    <div class="card__container">
      <ItemCard
        v-for="(item, index) in options"
        :key="index"
        :item="item"
        @onSelect="onSelect"
        @onHover="onMouseEnter"
      />
    </div>
  </div>
</template>

<script>
import ItemCard from '../components/ItemCard';
import {mapMutations, mapState} from "vuex";
import {mutations} from "@/store/newonboarding/types.js";

export default {
  name: "Target",
  components: {
    ItemCard,
  },
  data() {
    return {
      options: [
        {
          icon: "icon-new-landing-page",
          name: "newonboarding.welcome.option.landing.title",
          value: "Landing Page",
          description: "newonboarding.welcome.option.landing.des"
        },
        {
          icon: "icon-new-product-page",
          name: "newonboarding.welcome.option.ppage.title",
          value: "Product Page",
          description: "newonboarding.welcome.option.ppage.des",
        },
        {
          icon: "icon-new-homepage",
          name: "newonboarding.welcome.option.home.title",
          value: "Home Page",
          description: "newonboarding.welcome.option.home.des"
        },
        {
          icon: "icon-new-collection-page",
          name: "newonboarding.welcome.option.collection.title",
          value: "Collection Page",
          description: 'newonboarding.welcome.option.collection.des'
        },
        {
          icon: "icon-new-blog",
          name: "newonboarding.welcome.option.blog.title",
          value: "Blog Post",
          description: 'newonboarding.welcome.option.blog.des'
        },
        {
          icon: "icon-complete-store",
          name: "newonboarding.welcome.option.completed.title",
          value: "Complete Store",
          description: "newonboarding.welcome.option.completed.des"
        },
      ]
    }
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    })
  },
  methods: {
    ...mapMutations("newonboarding", {
      obsPageObjective: mutations.OBS_PAGE_OBJECTIVE,
      obsHoverPageObjective: mutations.OBS_HOVER_PAGE_OBJECTIVE,
    }),
    onMouseEnter(name) {
      this.obsHoverPageObjective({data: name});
    },
    onSelect(name) {
      const shopifyDomain = this.shopInfo && this.shopInfo.shopifyDomain
      this.obsPageObjective({data: name, shopifyDomain: shopifyDomain});
    },
    onInputFocus() {
      this.obsPageObjective("");
    }
  },
}
</script>

<style lang="scss" scoped>
.card__container {
  width: 424px;
  display: grid;
  gap: 16px;
  grid-template-columns: auto auto;
  grid-template-rows: auto auto auto;
}
</style>
